"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = ["columnCount", "columnGap", "columnRule", "columnRuleColor", "columnRuleWidth", "columns", "flex", "flexBasis", "flexGrow", "flexShrink", "order", "perspective", "perspectiveOrigin", "perspectiveOriginX", "perspectiveOriginY", "scrollSnapCoordinate", "scrollSnapDirection", "textDecoration", "textDecorationColor", "transform", "transformOrigin", "transformOriginX", "transformOriginY", "transformOriginZ", "transformStyle"];
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-prefixer/lib/animatableValues.js
 ** module id = 195
 ** module chunks = 1
 **/